import React, { useRef, useEffect, useCallback } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import './Carte.css';

const SITE_URL = 'https://baptiste-lemattre.fr';

function Carte({ onClose }) {
  const cardRef = useRef(null);
  const overlayRef = useRef(null);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose?.();
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [handleKeyDown]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose?.();
  };

  const handleDownload = async () => {
    const canvas = await html2canvas(cardRef.current, { scale: 3, useCORS: true });
    const link = document.createElement('a');
    link.download = 'carte-baptiste-lemattre.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(SITE_URL);
  };

  return (
    <div
      className="carte-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-label="Carte de visite Baptiste LEMATTRE"
    >
      <div className="carte-modal">
        <div className="carte-modal-inner">
          <button
            className="carte-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            ✕
          </button>

          <div className="carte-card" ref={cardRef}>
            <div className="carte-header">
                {/* Photo à gauche */}
                <img
                  className="carte-photo"
                  src="/assets/img/photo.png"
                  alt="Baptiste LEMATTRE"
                  crossOrigin="anonymous"
                />

                {/* Titre au centre */}
                <div className="carte-titles">
                  <p className="carte-name">Baptiste LEMATTRE</p>
                  <p className="carte-role">Ingénieur réseaux et sécurité</p>
                </div>

                {/* Logo à droite, en face de la photo */}
                <img
                  src="/logo_BL.svg"
                  alt="Logo Baptiste LEMATTRE"
                  className="carte-logo"
                  crossOrigin="anonymous"
                />
              </div>
            <div className="carte-body">
              <div className="carte-infos">
                <p className="carte-info-item">✉ lemattre.b@gmail.com</p>
                <p className="carte-info-item">🌐 baptiste-lemattre.fr</p>
              </div>
              {/* Plus que le QR code ici */}
              <div className="carte-qr">
                <QRCodeSVG value={SITE_URL} size={72} />
              </div>
            </div>
          </div>

          <div className="carte-actions">
            <button onClick={handleDownload} className="btn-primary">
              Télécharger PNG
            </button>
            <button onClick={handleCopyLink} className="btn-secondary">
              Copier le lien
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Carte;